import React, { useMemo } from "react";
import { DirectReportsTable } from "@/components/layouts/LeadAnalysis/DirectReportTable";
import { useLeadAnalysisBreadcrumbs } from "@/components/layouts/LeadAnalysis/LeadAnalysisBreadcrumbsProvider";
import { UserData } from "@/entities/users/types";

interface LeadAnalysisTableCardControllerProps {
  dataTestPrefix: string;
  title: string;
  subtitle: string;
  isLoading?: boolean;
}

interface UserMap {
  [id: string]: UserData;
}

export const LeadAnalysisTableCardController: React.FC<
  LeadAnalysisTableCardControllerProps
> = ({ dataTestPrefix, isLoading }) => {
  const { dynamicTableData, handleRowClick, directReportsData } =
    useLeadAnalysisBreadcrumbs();

  const tableDataWithUsers = useMemo(() => {
    if (!directReportsData?.overall || !dynamicTableData) {
      return [];
    }
    const userMap = dynamicTableData.reduce<UserMap>((map, user) => {
      map[user.id] = user;
      return map;
    }, {});

    return directReportsData.overall
      .filter((item) => userMap[item.id])
      .map((item) => ({
        ...item,
        user: userMap[item.id]
      }));
  }, [directReportsData?.overall, dynamicTableData]);

  return (
    <div
      className="flex flex-col gap-4 w-full"
      data-test={`${dataTestPrefix}-container`}
    >
      <DirectReportsTable
        data={tableDataWithUsers || []}
        isLoading={isLoading}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default LeadAnalysisTableCardController;
